import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MasonryService} from "../../../../../../services/local/masonry.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../../store";
import {first, map, switchMap, tap} from "rxjs/operators";
import {filter} from "rxjs";
import {Utils} from "../../../../../../shared/utils/utils";
import {Observable} from "rxjs";
import {BuilderTemplates} from "../../../../builder-templates/builder-templates";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-ai-builder-create-page-templates',
    templateUrl: './ai-builder-create-page-templates.component.html',
    styleUrls: ['./ai-builder-create-page-templates.component.scss'],
    standalone: false
})
export class AiBuilderCreatePageTemplatesComponent implements OnInit {

  @Output() onBack: EventEmitter<{ step: string | void, templateScreenshot?: string }> = new EventEmitter<{ step: string | void, templateScreenshot?: string }>();
  @Output() onRunAi: EventEmitter<{ selectedTemplate?: any }> = new EventEmitter<{ selectedTemplate?: string }>();
  @Output() templateCategory: EventEmitter<any> = new EventEmitter<string>();
  @Output() showUpgradePopup: EventEmitter<any> = new EventEmitter<string>();
  @Input() selectedCategory: string;
  @Input() hideBackButton?: boolean;
  @Input() demoUser?: boolean;

  public categories = [];
  public templates$: Observable<BuilderTemplates[]>;
  public builderTemplates: BuilderTemplates[];
  public filteredBuilderTemplates: BuilderTemplates[];
  public selectedTemplate: BuilderTemplates;
  public templateScreenshot: string;

  constructor(
    private _masonry: MasonryService,
    private _activeModal: DbActiveModal,
    private _store: Store<fromStore.DbStoreState>,
  ) {
  }

  ngOnInit() {
    this._activeModal.whiteCloseBtn(false);
    this._getTemplates();
  }

  public changeStep(step, templateScreenshot?): void {
    this._activeModal.whiteCloseBtn(false);
    this.onBack.emit({step: step.step, templateScreenshot: (templateScreenshot || null)});
  }

  private _getTemplates(): void {
    this.templates$ = this._store.select(fromStore.getBuilderTemplatesLoaded)
      .pipe(
        filter(templatesLoaded => templatesLoaded),
        switchMap(() => this._store.select(fromStore.getBuilderTemplates)),
        first(),
        map(templates => Utils.sort(
          templates, (a, b): number => {
            const l = new Date(a.creationDate).getTime(), r = new Date(b.creationDate).getTime();
            return l < r ? 1 : -1;
          })),
        tap(t => {
          console.log(t);
        })
      );

    this.templates$
      .subscribe((templates: BuilderTemplates[]) => {
        this.builderTemplates = templates;
        this.filteredBuilderTemplates = templates;
        this.builderTemplates.map((template: BuilderTemplates, index) => {
          template.categories && !this.categories.includes(template.categories) && this.categories.push(template.categories);
          index === 0 && this.categories.length && this.filterByCategory(this.selectedCategory || this.categories[index]);
        });
        /*this.categories = (this.builderTemplates.reduce((newEntities, template) => {
          newEntities.push(template.categories);
          return newEntities;
        }, [])).filter((x, i, a) => a.indexOf(x) === i);*/
      });
  }

  public filterByCategory(title: string): void {
    this.selectedCategory = title;
    this.filteredBuilderTemplates = this.builderTemplates.filter((template: BuilderTemplates) => template.categories && template.categories === title);
    this.templateCategory.emit(this.selectedCategory);
  }

  public orderImages(): void {
    this._masonry.resizeAllMasonryItems('db-ai-builder-create-page-templates__templates', 'card', 16, true);
  }

  public selectTemplate(template: BuilderTemplates): void {
    this.selectedTemplate = template;
  }

  public runAiBuilder(): void {
    if (this.demoUser) {
      return this.showUpgradePopup.emit('Pre-made');
    }
    this.onRunAi.emit({selectedTemplate: this.selectedTemplate});
  }

  public previewTemplate(templateScreenshot: string): void {
    this.templateScreenshot = templateScreenshot;
    this.changeStep({step: 'preview'}, templateScreenshot);
  }
}
